const paymentOfferStyle = {
  mainGrid: { marginTop: "1%", marginBottom: "1%" },

};

export default paymentOfferStyle;
